import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class CheckboxesService {

  alertes = ["ROADWORKS","CONGESTION","INCIDENT","MOUNTAINPASS","METEO","CONES"]; // Nom de les capes del tipus alertes
  serveis = ["GAS_STATION","RADAR","PARKING","PARKANDRIDE","TRAMS_PERILL"]; // Nom de les capes del tipus servei
  zoomLayers = ["CAMERA", "RADAR", "GAS_STATION", "PARKING", "PARKANDRIDE"]; //Nom de les capes que necessiten un zoom mínim per ser mostrades

  /**BehaviorSubject = Subject però hem d'inicialitzar el seu valor */
  private _checked = new BehaviorSubject<string[]>([]);
  private checkedData = ['CONGESTION','METEO','MOUNTAINPASS'];
  readonly checked = this._checked.asObservable();

  getCheckboxes() {
    this._checked.next(this.checkedData);
    return this._checked.asObservable();
  }

  addCheckbox(servei: string): void {
    if(this.alertes.includes(servei) || this.serveis.includes(servei) || this.zoomLayers.includes(servei)){
      this.checkedData.push(servei);
      this._checked.next(this.checkedData);
    }

  }

  deleteCheckbox(servei: string): void {
    var index = this.checkedData.indexOf(servei);
    this.checkedData.splice(index,1);
    this._checked.next(this.checkedData);
  }

  clearCheckboxes(): void{
    this.checkedData = [];
    this._checked.next(this.checkedData);
  }

  constructor() { }


}
